export default __webpack_public_path__ + "static/media/tropicana-cenang.2a9f4c0a.png";